// jQuery globalt (för Bootstrap 3 och Kendo UI Core)
import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

// Bootstrap 3's dropdown via CommonJS (viktigt!)
import 'bootstrap/dist/js/bootstrap.js'

import "./FileManager/webDavInitializeLicense.js";
import websocketPlugin from "./plugins/websocketPlugin.js";
import { createApp, nextTick, h } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store'

// Polyfills & CSS
import './polyfill'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'floating-vue/dist/style.css'

// Plugins
import FloatingVue from 'floating-vue'
import { Tooltip, Dropdown } from 'floating-vue'
import VueScrollTo from 'vue-scrollto'
import dateUtils from "./utils/date.js";
import filtersPlugin from './Filters/filtersPlugin';

import '@progress/kendo-theme-bootstrap/dist/all.css'

import {
    Chart,
    ChartTitle,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartValueAxis,
    ChartValueAxisItem
} from '@progress/kendo-vue-charts'
import AppDatePicker from '@/components/Kendo/AppDatePicker.vue';
import AppDateTimePicker from '@/components/Kendo/AppDateTimePicker.vue';
import AppTimePicker from '@/components/Kendo/AppTimePicker.vue';

const { registerLicense } = require('@syncfusion/ej2-base');
import { loadCldr, setCulture } from '@syncfusion/ej2-base';


import * as svNumbers from 'cldr-data/main/sv/numbers.json';
import * as svTimeZoneNames from 'cldr-data/main/sv/timeZoneNames.json';
import * as svCaGregorian from 'cldr-data/main/sv/ca-gregorian.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
loadCldr(
    numberingSystems,
    svNumbers,
    svTimeZoneNames,
    svCaGregorian
);
setCulture('sv');
// Bas
//import '@syncfusion/ej2-base/styles/bootstrap.css';
//import '@syncfusion/ej2-buttons/styles/bootstrap.css';
//import '@syncfusion/ej2-calendars/styles/bootstrap.css';
//import '@syncfusion/ej2-dropdowns/styles/bootstrap.css';
//import '@syncfusion/ej2-inputs/styles/bootstrap.css';
//import '@syncfusion/ej2-layouts/styles/bootstrap.css';
//import '@syncfusion/ej2-navigations/styles/bootstrap.css';
//import '@syncfusion/ej2-popups/styles/bootstrap.css';
//import '@syncfusion/ej2-grids/styles/bootstrap.css';
//import '@syncfusion/ej2-treegrid/styles/bootstrap.css';
//import '@syncfusion/ej2-gantt/styles/bootstrap.css';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxfeHRTQmlcU0F+V0dWYEo=');
//ORg4AjUWIQA/Gnt2XFhhQlJHfVhdXGVWfFN0QHNRdV51fldEcC0sT3RfQFhjT39Vdk1iUH9dd3RXQ2teWA==

//Språkstöd Kendo
import { IntlProvider, LocalizationProvider, load, loadMessages } from '@progress/kendo-vue-intl'

//CLDR för svenska
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import numbers from 'cldr-numbers-full/main/sv/numbers.json'
import currencies from 'cldr-numbers-full/main/sv/currencies.json'
import caGregorian from 'cldr-dates-full/main/sv/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/sv/dateFields.json'
//import svMessages from '@progress/kendo-vue-intl/locales/sv/all.json'

loadMessages({
    // Calendar / Date inputs
    'calendar.today': 'Idag',
    'datepicker.toggleCalendar': 'Öppna kalender',

    // DateTimePicker (flikar + knappar)
    'datetimepicker.date': 'Datum',
    'datetimepicker.time': 'Tid',
    'datetimepicker.cancel': 'Avbryt',
    'datetimepicker.set': 'Välj',
    'datetimepicker.toggleDateTimeSelector': 'Öppna datum-/tidsväljare',

    // TimePicker
    'timepicker.now': 'Nu',
    'timepicker.selectNow': 'Välj nu',
    'timepicker.cancel': 'Avbryt',
    'timepicker.set': 'Välj',
    'timepicker.toggleTimeSelector': 'Öppna tidsväljare',
    'timepicker.toggleClock': 'Öppna klocka',

    // (valfritt) kalendernavigering
    'calendar.prevView': 'Föregående',
    'calendar.nextView': 'Nästa'
}, 'sv-SE')

load(likelySubtags, weekData, currencyData, numbers, currencies, caGregorian, dateFields)

// Moment (för datumhantering)
import moment from 'moment'

moment.updateLocale('sv', { week: { dow: 1 } })

const pinia = createPinia();

// Skapa appen
const app = createApp({
    render: () =>
        h(LocalizationProvider, { language: 'sv-SE' }, {
            default: () =>
                h(IntlProvider, { locale: 'sv-SE' }, { default: () => h(App) })
        })
});
app.use(pinia);
app.use(router)
app.use(store)
app.use(FloatingVue)
app.use(VueScrollTo)
app.use(dateUtils);
app.use(filtersPlugin);
app.use(websocketPlugin);


app.component('Chart', Chart)
app.component('ChartTitle', ChartTitle)
app.component('ChartLegend', ChartLegend)
app.component('ChartSeries', ChartSeries)
app.component('ChartSeriesItem', ChartSeriesItem)
app.component('ChartCategoryAxis', ChartCategoryAxis)
app.component('ChartCategoryAxisItem', ChartCategoryAxisItem)
app.component('ChartTooltip', ChartTooltip)
app.component('ChartValueAxis', ChartValueAxis)
app.component('ChartValueAxisItem', ChartValueAxisItem)
app.component('DatePicker', AppDatePicker);
app.component('DateTimePicker', AppDateTimePicker);
app.component('TimePicker', AppTimePicker);


// Mounta appen
app.mount('#app')

// Återsätt Bootstrap-dropdowns efter routing
router.afterEach(() => {
    nextTick(() => {
        setTimeout(() => {
            try {
                $('[data-toggle="dropdown"]').dropdown()
            } catch (e) {
                console.warn('Dropdown init fail:', e)
            }
        }, 0)
    })
})
